export const CAROUSEL_DEFAULT_ARGS = ({
  modules,
  $prevButton,
  $nextButton,
  updateCallback,
  isPrefersReducedMotion = false
}) => {
  return {
    modules: modules,
    speed: isPrefersReducedMotion ? 0 : 400,
    effect: isPrefersReducedMotion ? 'fade' : 'slide',
    loop: true,
    slidesPerView: 'auto',

    navigation: {
      prevEl: $prevButton,
      nextEl: $nextButton
    },
    breakpoints: {
      700: {}
    },
    on: {
      init: updateCallback ? updateCallback : () => {},
      breakpoint: updateCallback ? updateCallback : () => {},
      destroy: updateCallback ? updateCallback : () => {}
    }
  };
};

export const CAROUSEL_THERAPIES_ARGS = ({
  modules,
  $prevButton,
  $nextButton,
  updateCallback,
  isPrefersReducedMotion = false
}) => {
  return {
    modules: modules,
    speed: isPrefersReducedMotion ? 0 : 400,
    effect: isPrefersReducedMotion ? 'fade' : 'slide',
    loop: true,
    mousewheel: true,
    slidesPerView: 1,

    navigation: {
      prevEl: $prevButton,
      nextEl: $nextButton
    },
    breakpoints: {
      700: {}
    },
    on: {
      init: updateCallback ? updateCallback : () => {},
      breakpoint: updateCallback ? updateCallback : () => {},
      destroy: updateCallback ? updateCallback : () => {}
    }
  };
};

export const CAROUSEL_CLINICAL_WORKS_ARGS = ({
  modules,
  $prevButton,
  $nextButton,
  updateCallback,
  isPrefersReducedMotion = false
}) => {
  return {
    modules,
    speed: 0, // ← убираем анимацию движения
    loop: true,
    slidesPerView: 'auto',
    allowTouchMove: false, // ← если свайп не нужен
    watchSlidesProgress: true,
    virtualTranslate: true, // ← ВАЖНО: не двигает wrapper

    navigation: {
      prevEl: $prevButton,
      nextEl: $nextButton
    },

    on: {
      init: updateCallback ?? (() => {}),
      slideChange: updateCallback ?? (() => {})
    }
  };
};

export const CAROUSEL_CLINICAL_ALLOEGENIC_ARGS = ({
  modules,
  updateCallback,
  isPrefersReducedMotion = false
}) => {
  return {
    modules: modules,
    // По умолчанию (мобилка) карусель включена
    enabled: true,
    watchOverflow: true,
    speed: isPrefersReducedMotion ? 0 : 400,
    effect: isPrefersReducedMotion ? 'fade' : 'slide',
    loop: false,
    slidesPerView: 'auto',

    scrollbar: {
      el: '[data-carousel-progress]'
    },

    breakpoints: {
      // На десктопе "выключаем" Swiper, чтобы блок вёл себя как обычная разметка
      768: {
        enabled: false,
        allowTouchMove: false
      }
    },
    on: {
      init: updateCallback ? updateCallback : () => {},
      breakpoint: updateCallback ? updateCallback : () => {},
      destroy: updateCallback ? updateCallback : () => {}
    }
  };
};

export const CAROUSEL_HERO_MAIN_ARGS = ({
  modules,
  $prevButton,
  $nextButton,
  updateCallback,
  isPrefersReducedMotion = false
}) => {
  return {
    modules: modules,
    // По умолчанию (мобилка) карусель включена
    enabled: true,
    watchOverflow: true,
    speed: isPrefersReducedMotion ? 0 : 400,
    effect: 'fade',
    fadeEffect: { crossFade: true },
    loop: true,
    slidesPerView: 1,

    navigation: {
      prevEl: $prevButton,
      nextEl: $nextButton
    },

    scrollbar: {
      el: '[data-carousel-progress]'
    },

    pagination: {
      el: '[data-carousel-pagination]',
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '">' + (index + 1) + '</span>';
      }
    },

    on: {
      init: updateCallback ? updateCallback : () => {},
      breakpoint: updateCallback ? updateCallback : () => {},
      destroy: updateCallback ? updateCallback : () => {}
    }
  };
};

export const CAROUSEL_THERAPIES_WORKS_ARGS = ({
  modules,
  updateCallback,
  $scrollbar,
  isPrefersReducedMotion = false
}) => {
  return {
    modules: modules,
    // По умолчанию (мобилка) карусель включена
    enabled: true,
    watchOverflow: true,
    speed: isPrefersReducedMotion ? 0 : 400,
    effect: isPrefersReducedMotion ? 'fade' : 'slide',
    loop: false,
    slidesPerView: 'auto',

    scrollbar: {
      el: $scrollbar
    },

    breakpoints: {
      // На десктопе "выключаем" Swiper, чтобы блок вёл себя как обычная разметка
      992: {
        enabled: false,
        allowTouchMove: false
      }
    },
    on: {
      init: updateCallback ? updateCallback : () => {},
      breakpoint: updateCallback ? updateCallback : () => {},
      destroy: updateCallback ? updateCallback : () => {}
    }
  };
};

export const CAROUSEL_THERAPIES_HOW_ARGS = ({
  modules,
  updateCallback,
  $scrollbar,
  isPrefersReducedMotion = false
}) => {
  return {
    modules: modules,
    // По умолчанию (мобилка) карусель включена
    enabled: true,
    watchOverflow: true,
    speed: isPrefersReducedMotion ? 0 : 400,
    effect: isPrefersReducedMotion ? 'fade' : 'slide',
    loop: false,
    slidesPerView: 'auto',

    scrollbar: {
      el: $scrollbar
    },

    breakpoints: {
      // На десктопе "выключаем" Swiper, чтобы блок вёл себя как обычная разметка
      768: {
        enabled: false,
        allowTouchMove: false
      }
    },
    on: {
      init: updateCallback ? updateCallback : () => {},
      breakpoint: updateCallback ? updateCallback : () => {},
      destroy: updateCallback ? updateCallback : () => {}
    }
  };
};

export const CAROUSEL_LISTING_GALLERY_ARGS = ({
  modules,
  updateCallback,
  isPrefersReducedMotion = false
}) => {
  return {
    modules: modules,
    speed: isPrefersReducedMotion ? 0 : 400,
    effect: isPrefersReducedMotion ? 'fade' : 'slide',
    slidesPerView: 1.1,

    on: {
      init: updateCallback ? updateCallback : () => {},
      breakpoint: updateCallback ? updateCallback : () => {},
      destroy: updateCallback ? updateCallback : () => {}
    }
  };
};

export const CAROUSEL_PUBLICATIONS_ARGS = ({
  modules,
  $prevButton,
  $nextButton,
  updateCallback,
  isPrefersReducedMotion = false
}) => {
  return {
    modules: modules,
    speed: isPrefersReducedMotion ? 0 : 400,
    effect: isPrefersReducedMotion ? 'fade' : 'slide',
    slidesPerView: 'auto',

    navigation: {
      prevEl: $prevButton,
      nextEl: $nextButton
    },
    scrollbar: {
      el: '.c-therapies-publications_carousel_progress'
    },

    on: {
      init: updateCallback ? updateCallback : () => {},
      breakpoint: updateCallback ? updateCallback : () => {},
      destroy: updateCallback ? updateCallback : () => {}
    }
  };
};
